(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/event-analysis.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/event-analysis.js');
"use strict";


const {
  useSelector
} = ReactRedux;
const {
  selectAuthorProfile
} = svs.components.sportinfo.gameAnalysesRedux.selectors;
const {
  useAnalysisOutcomes,
  useParticipantsNames
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const {
  getOutcomeLabelsForEventType
} = svs.components.sport.tipsenShared;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  Outcome
} = svs.components.lbUi.outcome;
const isSelected = (outcomes, sign) => outcomes.some(outcome => outcome.outcomeNumber === sign.toString());
const AnalyseOutcomesScore = _ref => {
  let {
    branding,
    matchAnalysis
  } = _ref;
  const authorProfile = useSelector(state => selectAuthorProfile(state, matchAnalysis.authorId));
  const outcomes = useAnalysisOutcomes(matchAnalysis);
  const {
    awayTeam,
    homeTeam
  } = useParticipantsNames(matchAnalysis);
  const homeTeamOutcomes = outcomes[0];
  const awayTeamOutcomes = outcomes[1];
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "pg_analyse__event__info__prediction__title"
  }, authorProfile.authorLongName), React.createElement("div", {
    className: "pg_analyse__event__info__prediction__info"
  }, React.createElement("span", {
    className: "pg_analyse__event__info__prediction__info__title"
  }, homeTeam.name), React.createElement("span", {
    className: "pg_analyse__event__info__prediction__info__outcomes"
  }, homeTeamOutcomes.map(outcome => React.createElement(Outcome, {
    branding: branding,
    dataTestId: "analyses_outcome_score_".concat(homeTeam.name, "_").concat(outcome.description),
    isSelected: true,
    key: "analyses_outcome_score_".concat(homeTeam.name, "_").concat(outcome.description),
    sign: outcome.description
  })))), React.createElement("div", {
    className: "pg_analyse__event__info__prediction__info"
  }, React.createElement("span", {
    className: "pg_analyse__event__info__prediction__info__title"
  }, awayTeam.name), React.createElement("span", {
    className: "pg_analyse__event__info__prediction__outcomes"
  }, awayTeamOutcomes.map(outcome => React.createElement(Outcome, {
    branding: branding,
    dataTestId: "analyses_outcome_score_".concat(homeTeam.name, "_").concat(outcome.description),
    isSelected: true,
    key: "analyses_outcome_score_".concat(homeTeam.name, "_").concat(outcome.description),
    sign: outcome.description
  })))));
};
const AnalyseOutcomes = _ref2 => {
  let {
    branding,
    eventTypeId,
    matchAnalysis,
    sportType
  } = _ref2;
  const outcomes = useAnalysisOutcomes(matchAnalysis)[0];
  const labels = getOutcomeLabelsForEventType(eventTypeId, sportType);
  const authorProfile = useSelector(state => selectAuthorProfile(state, matchAnalysis.authorId));
  return React.createElement(React.Fragment, null, React.createElement("span", {
    className: "pg_analyse__event__info__prediction__title"
  }, authorProfile.authorLongName), React.createElement("span", {
    className: "pg_analyse__event__info__prediction__outcomes"
  }, labels.map(outcome => React.createElement(Outcome, {
    branding: branding,
    dataTestId: "analyses_outcome_score_".concat(authorProfile.authorLongName, "_").concat(outcome.text),
    isSelected: isSelected(outcomes, outcome.sign),
    key: "analyses_outcome_score_".concat(authorProfile.authorLongName, "_").concat(outcome.text),
    sign: outcome.text
  }))));
};
const EventAnalysis = _ref3 => {
  let {
    matchAnalysis,
    isExpanded = false,
    branding,
    eventTypeId,
    sportType
  } = _ref3;
  const isResult = eventTypeId === EventTypeId.RESULT;
  return React.createElement("div", {
    className: "pg_analyse__event__info ".concat(isResult ? 'pg_analyse__event__info--score' : '')
  }, React.createElement("div", {
    className: "pg_analyse__event__info__prediction ".concat(isResult ? 'pg_analyse__event__info__prediction--score' : '')
  }, isResult && React.createElement(AnalyseOutcomesScore, {
    branding: branding,
    matchAnalysis: matchAnalysis
  }), !isResult && React.createElement(AnalyseOutcomes, {
    branding: branding,
    eventTypeId: eventTypeId,
    matchAnalysis: matchAnalysis,
    sportType: sportType
  })), isExpanded ? React.createElement("div", {
    className: "f-content",
    dangerouslySetInnerHTML: {
      __html: matchAnalysis.body
    }
  }) : null);
};
setGlobal('svs.component.analyze.EventAnalysis', EventAnalysis);

 })(window);